export const getReactKeyFromArgs = (...args) => {
  return args.join('_');
};
